// extracted by mini-css-extract-plugin
export default {"tipBox":"tipBox-444a","formContainer":"formContainer-e265","ctaBtn":"ctaBtn-6149"};